<template>
  <Form :model="formItem" :label-width="20" ref="booking">
    <h1 style="text-align: center; color:red; margin-top: 20px;">{{$t('pages_cleaner_index_258')}}</h1>
    <FormItem style="margin-top: 40px;">
      <CheckboxGroup v-model="formItem.items">
        <Checkbox :label="$t('pages_booking_store_products_index_213')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_booking_store_products_index_214')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_bookings_new_232')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_259')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_260')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_bookings_index_229')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_261')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_262')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_263')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_264')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_265')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_266')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_267')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_268')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_269')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_270')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_271')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_272')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_273')" border style="margin-top: 10px"></Checkbox>
        <Checkbox :label="$t('pages_cleaner_index_274')" border style="margin-top: 10px"></Checkbox>
      </CheckboxGroup>
    </FormItem>
    <Form-item>
      <Poptip :title="$t('pages_cleaner_index_275')" @on-ok="handleSubmit" confirm placement="right">
        <Button type="error" size="large" long>{{$t('libs_table_render_70')}}</Button>
      </Poptip>
    </Form-item>
  </Form>
</template>

<script>
import i18n from '../../locales/index'

import axios from 'axios'

export default {
  data () {
    return {
      formItem: {}
    }
  },
  methods: {
    async handleSubmit () {
      await axios.post('/settings/clear_data', {
        items: this.formItem.items
      })
      console.log(this.formItem)
    }
  }
}
</script>
